﻿import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/pg_insumos/insumos-selecionar";

export const Route = createFileRoute("/_authenticated/insumos-selecionar")({
  head: () => ({
    meta: [
      { title: "Selecionar insumo — Milky Moo Palmares" },
      { name: "description", content: "Selecione um insumo do cadastro." },
      { property: "og:title", content: "Selecionar insumo — Milky Moo Palmares" },
      { property: "og:description", content: "Selecione um insumo do cadastro." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: PaginaRota,
});
